module.exports = __webpack_public_path__ + "images/fa-365-logo-small.png";